import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  confirmModal: {
    width: 520,
  },
  messageModal: {
    font: "400 16px/24px Inter",
  },
  subMessageModal: {
    color: "#f79009",
    font: "italic 400 16px/24px Inter",
  },
}));

export default styles;
